import styles from './radio-broadcast.module.scss';
import IconMock from 'assets/mock/picture-16x9-1.png';
import Image from 'next/image';
import { Ether } from './ether';
import { IconShare, IconLike } from 'components/ui/icons/player';
import { useState } from 'react';

/* Массив заглушка на 15 элементов */
const arr = [...new Array(15)].fill({
  icon: 'https://mcdn.tvzvezda.ru/storage/old-radiozvezda/uploads/programs/preview/7b6d01605a.jpg',
  time: '12:30',
  title: 'Медаль "За взятие Парижа 19 марта 1814 года"',
  section: 'История награды',
});

export const RadioBroadcast = () => {
  const [isLike, setIslike] = useState(false);

  const onLike = () => setIslike(!isLike);

  return (
    <article className={styles.radio}>
      <section className={styles.detail}>
        <header className={styles.header}>Сейчас в эфире</header>
        <section className={styles.image}>
          <section className={styles.wrapper}>
            <Image height={250} width={250} alt={''} src={IconMock} />
            <button onClick={onLike} className={styles.btn}>
              <IconLike fill={!isLike ? 'white' : '#eb2f2c'} />
            </button>
          </section>
          <button className={styles.share}>
            <IconShare />
          </button>
        </section>
        <section className={styles.description}>
          <p className={styles.title}>{'Медаль "За взятие Парижа 19 марта 1814 года"'}</p>
          <p className={styles.text}>
            {
              'Почему медаль "За взятие Парижа 19 марта 1814 года" вручили русским войскам только в 1826 году - спустя 12 лет?'
            }
          </p>
          <p>История награды</p>
        </section>
      </section>
      <section className={styles.list}>
        <header className={styles.header}>Далее в эфире</header>
        <section>
          {arr.map((item, i) => (
            <Ether key={i} {...item} />
          ))}
        {/* Таблица эфира */}
        </section>
      </section>
    </article>
  );
};
